<template>
  <div class="decorates_box">
    <div class="decorate-row" v-for="rowItem in maxRow() + 1" :key="rowItem">
      <template v-for="colItem in maxCol() + 1" :key="colItem">
        <div
          class="decorates"
          :class="{ active: lightSet.lightData.ColorsCustom[encodeRowColNumber(rowItem - 1, colItem - 1)] > 0 }"
          :style="{ backgroundColor: integerToHex(lightSet.lightData.ColorsCustom[encodeRowColNumber(rowItem - 1, colItem - 1)] || 4294967040) }"
          @mousedown="handleBlockMouseDown(rowItem - 1, colItem - 1)"
          @mouseenter="handleBlockMouseEnter(rowItem - 1, colItem - 1)"
        ></div>
      </template>
    </div>
  </div>
</template>
<script setup lang="ts">
import { lightSet } from '@/service/driver/light_set'
import { integerToHex } from '@/tool/utility'
import { decodeRowColNumber, encodeRowColNumber } from '@libs/utils/tools'
import { ref, onMounted, onBeforeUnmount } from 'vue'

const isMouseDown = ref(false)
const selectedAdd = ref<boolean | null>(null)
const selectedBlocks = ref<number[]>([])

const getCurrentColor = () => {
  if (lightSet.effectColorTypeList().length >= 2) {
    if (lightSet.isFGSelected.value) {
      return lightSet.foregroundColor.value
    } else {
      return lightSet.backgroundColor.value
    }
  } else {
    return lightSet.foregroundColor.value
  }
}

const handleBlockMouseDown = (row: number, col: number) => {
  isMouseDown.value = true
  const key = encodeRowColNumber(row, col)
  selectedAdd.value = !selectedBlocks.value.includes(key)
  handleContinuousSelectData(row, col)
}

const handleBlockMouseEnter = (row: number, col: number) => {
  if (!isMouseDown.value) return
  handleContinuousSelectData(row, col)
}

const handleBlockMouseUp = () => {
  isMouseDown.value = false
  selectedAdd.value = null
  selectedBlocks.value = []
}

const handleContinuousSelectData = (row: number, col: number) => {
  console.log('handleContinuousSelectData', row, col)
  const key = encodeRowColNumber(row, col)
  const newColorsCustom = { ...lightSet.lightData.ColorsCustom }
  if (selectedAdd.value === null) {
    selectedAdd.value = !selectedBlocks.value.includes(key)
  }
  if (selectedAdd.value) {
    if (selectedBlocks.value.includes(key)) return
    selectedBlocks.value.push(key)
    newColorsCustom[key] = getCurrentColor()
  } else {
    selectedBlocks.value = selectedBlocks.value.filter((k) => k !== key)
    // 取消选中时清除颜色
    newColorsCustom[key] = 0
  }
  // 通过 setter 赋值，触发响应式和数据同步
  lightSet.lightData = {
    ...lightSet.lightData,
    LightLastIsCustom: true,
    ColorsCustom: newColorsCustom,
  }
}

const maxRow = (): number => {
  const rows = Object.entries(lightSet.lightData.ColorsCustom).map(([key, _]) => decodeRowColNumber(Number(key))[0])
  return Math.max(...rows)
}

const maxCol = (): number => {
  const cols = Object.entries(lightSet.lightData.ColorsCustom).map(([key, _]) => decodeRowColNumber(Number(key))[1])
  return Math.max(...cols)
}

onMounted(() => {
  document.addEventListener('mouseup', handleBlockMouseUp)
})
onBeforeUnmount(() => {
  document.removeEventListener('mouseup', handleBlockMouseUp)
})
</script>

<style lang="less" scoped>
.decorates_box {
  display: flex;
  flex-direction: column;
  gap: 6;
}
.decorate-row {
  display: flex;
  gap: 2px;
}
.decorates {
  width: 30px;
  height: 30px;
  cursor: pointer;
  border-radius: 2px;
  border: 2px solid #f7f7f7;
  &.active {
    border: 0px solid transparent !important;
  }
}
</style>
